import { createSelector } from 'reselect';
import { initialFavouriteState } from './../../reducers/Favorite/reducer';

const selectData = (state: any) => state.Favorite || initialFavouriteState;

export const makeFavorite = () => {
  return createSelector(
    [selectData],
    Favorite => Favorite
  );
};
export const getUpdatedId = () => {
  return createSelector(
    [selectData],
    Favorite => Favorite.updatedId
  );
};
